// fill="${color ? color : "currentColor"}"
// width=${width}
// height=${height}
// currentColor ใส่เเทนสี ที่ต้องการเปลี่ยน สีตาม  ConfigProvider theme
import PropTypes from 'prop-types'

import React from 'react'

const Index = ({ width = 16, height = 16, color }) => {
  const svgXml = `  <svg
          width=${width}
          height=${height}
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="50" cy="50" r="50" fill="${color ? color : '#13BBC4'}"  />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M72.5706 35.6802C73.0862 36.1959 73.3758 36.8952 73.3758 37.6244C73.3758 38.3536 73.0862 39.053 72.5706 39.5687L46.4456 65.6937C45.9299 66.2092 45.2306 66.4988 44.5014 66.4988C43.7722 66.4988 43.0728 66.2092 42.5571 65.6937L30.1821 53.3187C29.6812 52.8 29.404 52.1054 29.4103 51.3843C29.4165 50.6633 29.7057 49.9735 30.2156 49.4637C30.7255 48.9538 31.4152 48.6646 32.1363 48.6583C32.8573 48.652 33.552 48.9292 34.0706 49.4302L44.5014 59.8609L68.6821 35.6802C69.1978 35.1646 69.8972 34.875 70.6264 34.875C71.3556 34.875 72.0549 35.1646 72.5706 35.6802Z"
            fill="white"
          />
        </svg>

  
   `

  return (
    <div
      style={{ display: 'flex', alignItems: 'center' }}
      dangerouslySetInnerHTML={{ __html: svgXml }}
    />
  )
}
Index.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}
export default Index
